import { type WorkspaceTemplateConfig } from '~/components/Modals/BoardTemplateModal/types';

const getCurrentYear = () => new Date().getFullYear();

export const ECOMMERCE_TEMPLATE: WorkspaceTemplateConfig = {
  id: 'ecommerce',
  title: 'E-Commerce',
  description: 'Centralize creative and sales assets.',
  boards: [
    {
      title: 'Products',
      subBoards: [
        {
          title: 'Product Photography',
          subBoards: [{ title: 'Studio' }, { title: 'Lifestyle' }, { title: 'Detail Shots' }],
        },
        {
          title: 'Product Videos',
          subBoards: [{ title: 'Tutorials' }, { title: 'Unboxing' }, { title: 'Ads' }],
        },
        { title: 'By SKU' },
      ],
    },
    {
      title: 'Website Content',
      subBoards: [
        { title: 'Homepage Banners' },
        { title: 'Category Graphics' },
        { title: 'Product Detail Page Assets' },
        { title: 'Size Charts' },
      ],
    },
    {
      title: 'Marketing Assets',
      subBoards: [
        {
          title: 'Campaigns',
          subBoards: [
            {
              title: `Q1 ${getCurrentYear()} Launch`,
              subBoards: [{ title: 'Social Media' }, { title: 'Email' }, { title: 'Ads' }],
            },
            {
              title: `Black Friday ${getCurrentYear()}`,
              subBoards: [{ title: 'Social Media' }, { title: 'Email' }, { title: 'Ads' }],
            },
          ],
        },
        { title: 'Email Marketing (by Campaign)' },
        {
          title: 'Paid Ads',
          subBoards: [{ title: 'Search' }, { title: 'Display' }, { title: 'Social' }],
        },
      ],
    },
    {
      title: 'Brand Guidelines',
      subBoards: [
        { title: 'Logos' },
        { title: 'Brand Guidelines Document' },
        { title: 'Fonts' },
        { title: 'Color Palettes' },
        { title: 'Approved Brand Photography' },
      ],
    },
    {
      title: 'Customer Content',
      subBoards: [{ title: 'Reviews' }, { title: 'UGC Submissions' }],
    },
    {
      title: 'Corporate Assets',
      subBoards: [{ title: 'Analytics & Reports' }, { title: 'Presentations' }, { title: 'Press Kits' }],
    },
  ],
};
